/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum IndicatorError {
    TECHNICAL_ERROR = 'TECHNICAL_ERROR',
    NO_RESULT = 'NO_RESULT',
}
